import React from 'react';
import useClient from './useClient';
import Client from './Components/Client';

const ClientIndex: React.FC = () => {
  const clientProps = useClient();

  return (
  <Client/>
);
};
export default ClientIndex;
